module.exports = __webpack_public_path__ + "static/img/3.2.f7e7ceb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/3.2.png
// module id = 5EaG
// module chunks = 0